export var defaultProps = {
  ratio: "default"
};